import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import { $Elements, Durations, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Carousel ----------

	$('.content-section').each(function() {

		const section = this;

		$(section).find('.section-carousel, .column-carousel').each(function() {

			const carousel = this;

			if(!carousel.swiper) {

				const swiper = new Swiper(carousel, {
					speed: Durations.animations.ms,
					loop: false,
					observer: true,
					modules: [Navigation, Pagination],
					slidesPerView: 'auto',
					slidesPerGroupAuto: true,
					pagination: {
						el: section.querySelector('.swiper-pagination'),
						clickable: true,
					},
					navigation: {
						nextEl: section.querySelector('.swiper-button-next'),
						prevEl: section.querySelector('.swiper-button-prev'),
					},
				});
			}
		});
	});

	// ---------- Slideshow ----------

	$('.content-section').each(function() {

		const section = this;

		$(section).find('.section-slideshow, .column-slideshow').each(function() {

			const slideshow = this;

			if(!slideshow.swiper) {

				const swiper = new Swiper(slideshow, {
					speed: Durations.animations.ms,
					loop: true,
					observer: true,
					autoplay: true,
					effect: 'fade',
					modules: [Autoplay, EffectFade, Navigation, Pagination],
					fadeEffect: {
						crossFade: true,
					},
					pagination: {
						el: section.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: section.querySelector('.swiper-button-next'),
						prevEl: section.querySelector('.swiper-button-prev'),
					},
				});
			}
		});
	});
});
